var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonHomeOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.306 1.10698C8.21728 1.03781 8.108 1.00024 7.9955 1.00024C7.883 1.00024 7.77372 1.03781 7.685 1.10698L0.5 6.70948L1.1215 7.49548L2 6.81048V13C2.00053 13.265 2.10606 13.5191 2.29348 13.7065C2.4809 13.8939 2.73495 13.9995 3 14H13C13.2651 13.9995 13.5191 13.8939 13.7065 13.7065C13.8939 13.5191 13.9995 13.265 14 13V6.81498L14.8785 7.49998L15.5 6.71398L8.306 1.10698ZM9 13H7V8.99998H9V13ZM10 13V8.99998C10 8.73476 9.89464 8.48041 9.70711 8.29287C9.51957 8.10534 9.26522 7.99998 9 7.99998H7C6.73478 7.99998 6.48043 8.10534 6.29289 8.29287C6.10536 8.48041 6 8.73476 6 8.99998V13H3V6.03098L8 2.13598L13 6.03598V13H10Z",
    fill: "#E78C40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonHomeOrange);
export default __webpack_public_path__ + "static/media/carbon_homeOrange.156abe37530a2153cd0061f1a96739b3.svg";
export { ForwardRef as ReactComponent };